<template>
  <div
    class="focus"
    tabindex="0"
    :class="{ 'focus-checkbox': type === 'checkbox', disabled }"
    @focus="setListener"
    @blur="clearListener"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'VfocusField',

  props: {
    type: {
      type: [String],
      default: ''
    },

    disabled: {
      type: [Boolean],
      default: false
    }
  },

  methods: {
    keyDown(e) {
      if (e.keyCode === 13) {
        // Enter
        this.$el.children[0].click();
      }
    },

    setListener() {
      document.addEventListener('keydown', this.keyDown, false);
    },

    clearListener() {
      document.removeEventListener('keydown', this.keyDown, false);
    }
  }
};
</script>

<style lang="scss" scoped>
.focus {
  display: inline-flex;
  margin: 0;
  padding: 0;
  border: 0;
  border-radius: 0;
  background: rgba(0, 0, 0, 0);
  &:focus {
    outline-color: rgb(67, 122, 238); // #437AEE
    outline-offset: -2px;
    outline-style: auto;
    outline-width: 5px;
  }

  &.focus-checkbox {
    &:focus {
      outline: none;
      box-shadow: 0px 0px 0px 1px white, 0px 0px 0px 2px #437aee;
      border-radius: 2px;
    }

    &.disabled {
      &:focus {
        box-shadow: none;
      }
    }
  }
}
</style>
